"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestClaimOnboardingReward = exports.requestOnboardingReward = exports.isRewardUnavailableError = exports.ONBOARDING_REWARD_ERRORS = exports.ONBOARDING_REWARD_STATES = void 0;
const expected_errors_1 = require("@app/request/auth/expected-errors");
const apollo_1 = require("@app/util/apollo");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.ONBOARDING_REWARD_STATES = Object.freeze({
    AVAILABLE: 'AVAILABLE',
    CLAIMED: 'CLAIMED',
    EXPIRED: 'EXPIRED',
});
/**
 * Both mean „this organization has no bonus to give", not „something broke": no coupon
 * exists for its currency, or it has no Stripe customer yet. The card is hidden and nothing
 * is said, so neither may ever reach a toast.
 */
exports.ONBOARDING_REWARD_ERRORS = Object.freeze({
    UNAVAILABLE: 'organization.onboardingRewardUnavailable',
    NO_CUSTOMER: 'organization.onboardingRewardNoCustomer',
});
const EXPECTED_ERRORS = Object.values(exports.ONBOARDING_REWARD_ERRORS);
/** whether a failure is one of the two „no bonus here" answers rather than breakage */
const isRewardUnavailableError = (errors) => errors?.some((error) => (0, expected_errors_1.matchesExpected)(error, EXPECTED_ERRORS)) === true;
exports.isRewardUnavailableError = isRewardUnavailableError;
const REWARD_FIELDS = `
  amountOff
  durationInMonths
  totalAmountOff
  currency
  state
  code
  expiresAt
`;
const ONBOARDING_REWARD_QUERY = (0, graphql_tag_1.default) `
  query WorkspaceOnboardingReward($id: ID!) {
    workspace(id: $id) {
      id
      organization {
        id
        onboardingReward {
          ${REWARD_FIELDS}
        }
      }
    }
  }
`;
const CLAIM_ONBOARDING_REWARD_MUTATION = (0, graphql_tag_1.default) `
  mutation ClaimOnboardingReward($organization: ID!) {
    organizationOnboardingRewardClaim(organization: $organization) {
      ${REWARD_FIELDS}
    }
  }
`;
const requestOnboardingReward = async (variables, errorsCallback) => {
    const { data, errors } = await (0, apollo_1.query)(ONBOARDING_REWARD_QUERY, { variables });
    (0, expected_errors_1.processUnexpectedErrors)(errors, EXPECTED_ERRORS);
    errorsCallback?.(errors);
    return data?.workspace?.organization ?? undefined;
};
exports.requestOnboardingReward = requestOnboardingReward;
/**
 * Idempotent on the backend — a second call answers with the same code and grants no second
 * discount. `undefined` back is the documented rare race, and means „ask the query again".
 */
const requestClaimOnboardingReward = async (variables, errorsCallback) => {
    const { data, errors } = await (0, apollo_1.mutate)(CLAIM_ONBOARDING_REWARD_MUTATION, { variables });
    (0, expected_errors_1.processUnexpectedErrors)(errors, EXPECTED_ERRORS);
    errorsCallback?.(errors);
    return data?.organizationOnboardingRewardClaim ?? undefined;
};
exports.requestClaimOnboardingReward = requestClaimOnboardingReward;
exports.default = exports.requestOnboardingReward;
